import React, { useEffect, useState } from 'react';
import { sendAppleWebResponse, SocialLogin } from '../../../api/user';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageContainer from '../../../components/pages/PageContainer';
import Loader from '../../../components/Loader';

const AppleSignInHandler = () => {
  const [appleResponse, setAppleResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const idToken = params.get('id_token');

    if (code && idToken) {
      setAppleResponse({ code, idToken });
      handleSendAppleResponse({ code, idToken });
    } else {
      setError('No authorization code or ID token found.');
    }
  }, []);

  const handleSendAppleResponse = async (data) => {
    setLoading(true);
    try {
      const response = await sendAppleWebResponse(data);
      console.log('Apple Sign-In Response:', response.data);

      if (response.data && response.data.social_id) {
        handleSocialLogin(response.data);
      } else {
        setError('Invalid response from server.');
      }
    } catch (error) {
      console.error('Error sending Apple response:', error);
      setError('Failed to send Apple sign-in data to the server.');
      setLoading(false);
    }
  };

  const handleSocialLogin = async (data2) => {
    try {
          if (window.sendGoogleData) {
          window.sendGoogleData(data2); // Call the global function with the data
    }
      }
     catch (error) {
      toast.error('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <PageContainer>
    <div style={{ textAlign: 'center', marginTop: '50px' }}>

        {loading ? (
          <Loader />
        ) : error ? (
          <p style={{ color: 'red' }}>{error}</p>
        ) : null}


      <style>
        {`
          .loader {
            border: 4px solid rgba(0, 0, 0, 0.1);
            border-left-color: #000;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            animation: spin 1s linear infinite;
            margin: 20px auto;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
    </PageContainer>
    </>
  );
};

export default AppleSignInHandler;
